module.exports = function() {
  return new Worker("./" + "stylus-transpiler.5ccadabd.worker.js");
};